import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Tax} from './tax';
import {Supplier} from "../suppliers/supplier";

@Injectable()
export class TaxService {

  constructor(private http: Http) {

  }

  getAll(page: number = 1, sort: string = '') {
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    if(!currentfilter) {
      currentfilter = {};
    }

    const params = new URLSearchParams();
    params.set('page',  page+'');
    params.set('sorts', sort);
    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key])
      }
    }
    return this.http.get('taxes?' + params.toString()).map((response: Response) => response.json());
  }

  getById(_id: string) {
    return this.http.get('taxes/' + _id).map((response: Response) => response.json());
  }

  getAllTaxs() {
    return this.http.get('taxes/all').map((response: Response) => response.json());
  }
  getAllTaxstype(_type: any = 0) {
    return this.http.get('taxes/types/'+_type).map((response: Response) => response.json());
  }
  getTrashedById(_id: string) {
    return this.http.get('taxes/trashed/' + _id).map((response: Response) => response.json());
  }
  restoreTrashedById(_id: string) {
    return this.http.put('taxes/trashed/' + _id,{}).map((response: Response) => response.json());
  }

  create(tax: Tax) {
    return this.http.post('taxes', tax).map((response: Response) => response.json());
  }

  update(tax: Tax) {
    return this.http.put('taxes/' + tax.id, tax).map((response: Response) => response.json());
  }

  delete(_id: string) {
    return this.http.delete('taxes/' + _id).map((response: Response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/taxes/tax.service.ts